module.exports = __webpack_public_path__ + "static/media/smilingMan.5d6e338a.png";